import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

class Sidebar extends React.PureComponent {
  static get propTypes() {
    return {
      activeKey: PropTypes.string,
      children: PropTypes.node,
      data: PropTypes.object,
      hideSidebar: PropTypes.func,
      storePath: PropTypes.string,
      title: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      activeKey: null,
      data: {},
      hideSidebar: () => {},
      storePath: "",
      title: "",
    };
  }

  getActiveChild() {
    const { children, activeKey, data, hideSidebar, storePath } = this.props;

    let activeChild = null;
    React.Children.forEach(children, (child) => {
      if (activeKey === child.props.eventKey) {
        if (activeChild !== null) {
          console.warn(
            "Duplicate child entries with eventKey. " +
              "Children should have unique eventKeys.",
            activeKey,
          );
        }

        activeChild = React.cloneElement(child, {
          data,
          hideSidebar,
          storePath,
        });
      }
    });

    if (!activeChild) {
      console.warn(
        `No child matched activeKey "${activeKey}". ` +
          "Make sure you have defined a sidebar child with prop eventKey.",
      );
    }

    return activeChild;
  }

  render() {
    const { activeKey, hideSidebar, title } = this.props;

    if (!activeKey) {
      return null;
    }

    const activeChild = this.getActiveChild();

    return (
      <div className="ui-sidebar">
        <div className="sidebar-container container-fluid">
          <Row className="sidebar-header">
            <Col className="sidebar-title" xs={8}>
              <h4>{title}</h4>
            </Col>
            <Col xs={4}>
              <Button onClick={hideSidebar} className="pull-right" variant="secondary">
                Close
              </Button>
            </Col>
          </Row>
          <Row className="sidebar-content">
            <Col xs={12}>{activeChild}</Col>
          </Row>
        </div>
      </div>
    );
  }
}

export { Sidebar };
